import {makeAutoObservable, runInAction} from 'mobx'
import config from 'src/config'
import {MainStore} from 'src/store/MainStore'
import EmailHistoryItem from 'src/entities/EmailHistoryItem'
import EmailRecipientItem from 'src/entities/EmailRecipientItem'
import InstitutionEmailMessage from 'src/entities/InstitutionEmailMessage'

export class EmailHistoryStore {
  messages: EmailHistoryItem[] = []

  // Per-institution history (the institution's own Emails tab) — kept apart from the cross-institution
  // `messages` list so both screens can be open without clobbering each other.
  institutionMessages: InstitutionEmailMessage[] = []

  loadingInstitutionMessages: boolean = false

  recipients: EmailRecipientItem[] = []

  loading: boolean = false

  loadingRecipients: boolean = false

  constructor(readonly owner: MainStore) {
    makeAutoObservable(this)
  }

  getMessages = () => {
    runInAction(() => {
      this.loading = true
    })
    this.owner.loginStore
      .fetchWithUser(`${config.apiUrl}/Institutions/EmailMessages`)
      .then((res: any) => res.json())
      .then((data: any[]) => {
        if (data) {
          runInAction(() => {
            this.messages = data.map(m => new EmailHistoryItem(m))
          })
        }
      })
      .catch((e: any) => console.log('error:', e))
      .finally(() => {
        runInAction(() => {
          this.loading = false
        })
      })
  }

  // Emails this institution received: single-institution sends plus broadcasts it was part of.
  getInstitutionMessages = (institutionId?: number) => {
    if (!institutionId) {
      runInAction(() => {
        this.institutionMessages = []
      })
      return
    }
    runInAction(() => {
      this.loadingInstitutionMessages = true
    })
    this.owner.loginStore
      .fetchWithUser(
        `${config.apiUrl}/Institutions/${institutionId}/EmailMessages`
      )
      .then((res: any) => res.json())
      .then((data: any[]) => {
        runInAction(() => {
          this.institutionMessages = (data ?? []).map(
            m => new InstitutionEmailMessage(m)
          )
        })
      })
      .catch((e: any) => console.log('getInstitutionMessages error:', e))
      .finally(() => {
        runInAction(() => {
          this.loadingInstitutionMessages = false
        })
      })
  }

  getRecipients = (messageId: number) => {
    runInAction(() => {
      this.loadingRecipients = true
      this.recipients = []
    })
    this.owner.loginStore
      .fetchWithUser(
        `${config.apiUrl}/Institutions/EmailMessages/${messageId}/recipients`
      )
      .then((res: any) => res.json())
      .then((data: any[]) => {
        if (data) {
          runInAction(() => {
            this.recipients = data.map(r => new EmailRecipientItem(r))
          })
        }
      })
      .catch((e: any) => console.log('error:', e))
      .finally(() => {
        runInAction(() => {
          this.loadingRecipients = false
        })
      })
  }

  retryFailed = async (messageId: number) => {
    try {
      const res = await this.owner.loginStore.fetchWithUser(
        `${config.apiUrl}/Institutions/EmailMessages/${messageId}/retryFailed`,
        {method: 'POST'}
      )
      if (res.status === 200) {
        const count = await res.json()
        this.owner.setMessage(`${count} נמענים הוחזרו לשליחה.`, 'info')
        this.getMessages()
        this.getRecipients(messageId)
      } else {
        this.owner.setMessage('הפעולה נכשלה, נסה שוב.', 'error')
      }
    } catch (e) {
      this.owner.setMessage('הפעולה נכשלה, נסה שוב.', 'error')
    }
  }
}
